/**
 * WorkflowsModule - Root component for workflows module
 * 
 * Routes are relative to /workflows
 * This module provides vendor-focused repair workflow management
 */

import { Routes, Route } from 'react-router-dom';
import { ROLES } from '../../config/permissions';
import ProtectedRoute from '../../components/ProtectedRoute';
import { useAuth } from '../../context/AuthContext';

// Workflows Pages
import Workflows from './pages/Workflows';
import Templates from './pages/Templates';

export default function WorkflowsModule() {
  const { user } = useAuth();
  
  console.log('📋 [WorkflowsModule] Rendering:', {
    hasUser: !!user,
    userRole: user?.role,
    isDeveloper: user?.isDeveloper,
    modulesAccess: user?.modulesAccess
  });
  
  return (
    <Routes>
      {/* /workflows/ → Workflows Page (Repair Queue) */}
      <Route 
        index 
        element={
          <ProtectedRoute 
            requiredRole={[ROLES.ADMIN, ROLES.USER]}
            redirectTo="/workflows"
          >
            <Workflows />
          </ProtectedRoute>
        } 
      />
      
      {/* /workflows/templates → Templates Page */}
      <Route 
        path="templates" 
        element={
          <ProtectedRoute 
            requiredRole={[ROLES.ADMIN, ROLES.USER]}
            redirectTo="/workflows"
          >
            <Templates />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}
